import ShoppingCartItinerary from './ShoppingCartItinerary';
export default ShoppingCartItinerary;
